import { render, staticRenderFns } from "./CouponJoychat.vue?vue&type=template&id=98be8a46&scoped=true"
import script from "./CouponJoychat.vue?vue&type=script&lang=js"
export * from "./CouponJoychat.vue?vue&type=script&lang=js"
import style0 from "./CouponJoychat.vue?vue&type=style&index=0&id=98be8a46&prod&lang=less&scoped=true"
import style1 from "./CouponJoychat.vue?vue&type=style&index=1&id=98be8a46&prod&lang=scss"
import style2 from "./CouponJoychat.vue?vue&type=style&index=2&id=98be8a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98be8a46",
  null
  
)

export default component.exports